<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>

<template>
  <div>
    {{$t('news.template.candidate.val.new.consolidated.p1')}}
    {{news.textParams[0]}}
    {{$t('news.template.candidate.val.new.consolidated.p2')}}
  </div>
</template>
